<template>
    <div>
      <header-image
        :headerContents="headerContents"
        :headerBackground="'news'"
      />

      <div class="grid-container full searchAndFilter" >
        <div class="grid-x page-contents-8">
          <div class="small-12 cell">
           <label>Sort by </label>
            <select name="type"
                    class="reason"
                    tabindex="3"
                    v-model="filterType"
                    @change="filterByType(filterType)" >
              <option value="all">All</option>
              <option value="news">News</option>
              <option value="press">Press</option>
              <option value="awards">Awards</option>
            </select>
          </div>
        </div>
      </div>
      <div tabindex="5" ref="news" class="grid-container full page-contents-6 newsItems test">
        <div class="grid-x grid-padding-x small-up-1 medium-up-2 large-up-3 align-center">

          <div v-for="(news, index) in newsStories"
               :key="news.storyID"
               class="cell align-center">
            <rare-news-card
              :tabIndex="index+10"
              :newsID="news.news_index"
              :newsURL="news.news_url"
              :newsCat="news.news_type"
              :newsDate="news.news_date"
              :newsImage="news.news_img"
              :newsTitle="news.news_title"
              :newsTag="news.news_tag"
              :newsPreview="news.news_preview"
              @openNewsArticle="openNewsArticle"
            />
          </div>

        </div>
      </div>

    </div>
</template>

<script>

import axios from 'axios';

import RareStandardButton from '@/components/atoms/RareWebButton';
import RareConfigurableDropdown from 'rare-patternlab/input/RareConfigurableDropdown';

import HeaderHeroImage from '../../components/header/HeaderHeroImage';
import RareNewsHeaderContents from './components/RareNewsHeaderContents';
import RareNewsCard from './components/RareNewsCard';
import RareNewsNewsItemModal from './components/RareNewsNewsItemModal';

export default {
  name: 'news',
  components: {
    'header-image': HeaderHeroImage,
    'rare-news-header-contents': RareNewsHeaderContents,
    'rare-standard-button': RareStandardButton,
    'rare-dropdown': RareConfigurableDropdown,
    'rare-news-card': RareNewsCard,
    'rare-news-modal': RareNewsNewsItemModal,
  },
  data() {
    return {
      headerContents: 'rare-news-header-contents',
      newsModalOpen: false,
      newsIDtoOpen: null,
      oldYPos: 0,
      jobTitle: null,
      newsStories: null,
      filterType: '',
      referrer: '',
      apiURL: 'https://use47ihl4fb6wuhpzo5vixf3740yapti.lambda-url.eu-west-1.on.aws/?type=',
    };
  },
  methods: {
    openNewsArticle(newsURL) {
      this.$store.state.newsYPos = window.scrollY;
      this.$router.push({ path: `/news/${newsURL}` });
    },
    filterByType(filterType) {
      this.$router.push({ path: `/news/filter/${filterType}` });

      const requestURL = `${this.apiURL}${filterType}`;
      axios.get(requestURL).then((response) => {
        if (response.status === 200) {
          const articleListData = response.data;
          this.newsStories = articleListData;
        }
      });
    },
  },
  watch: {
    // eslint-disable-next-line
    $route() {
      this.closeNewsModal();
    },
  },
  mounted() {
    this.$refs.news.focus();

    this.$emit('hideNavigation');

    this.filterType = this.$route.params.filterType;

    if (typeof this.filterType === 'undefined') {
      this.filterType = 'all';
    }

    const requestURL = `${this.apiURL}${this.filterType}`;
    axios.get(requestURL).then((response) => {
      if (response.status === 200) {
        this.newsStories = response.data;
      }
    });
  },
  destroyed() {
    this.$emit('showNavigation');
  },
};
</script>

<style scoped>

  .newsItems:focus, .newsItems:active, .newsItems:focus-visible {
    outline: none;
  }


  label {
    display: inline-block;
    font-size: 16px;
    margin-right: 20px;
  }

  .reason {
    background-image: url('~@/assets/img/icons/down.svg');
    background-size: auto;
    border-color: #aeb1b4;
    background-color: transparent;
    color: #444c53;
    font-weight: bold;
    border-radius: 28px !important;
    cursor: pointer;
    font-size: 16px;
    height: 40px;
    width: 166px;
    letter-spacing: 0.2px;
    line-height: 1.5;
    margin-bottom: 0;
    padding-left: 24px;
  }

  @media only screen and (max-width: 640px) {
    .searchAndFilter {
      margin-top: 80px;
      margin-bottom: 20px;
    }

    .newsItems {
      margin-bottom: 40px;
    }
  }

  @media only screen and (min-width: 641px) {

    .searchAndFilter {
      margin-top: 70px;
      margin-bottom: 56px;
    }

    .newsItems {
      margin-bottom: 96px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/news/news.vue